var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Title from '../../../atoms/Title';
import { VerticalGap } from '../../../atoms/Gap/Gap';
import Desc from '../../../atoms/Desc';
import Input from '../../../atoms/Input';
import CtaBtn from '../../../atoms/CtaBtn';
import { neutralDay, scc } from '@teamsparta/design-system';
import { useAtom, useAtomValue } from 'jotai/index';
import { codeAtom, emailAtom, readWriteModalHistoryAtom } from '../../../../stores';
import { BottomContents, MainContents } from '../../../../styles/_common.style';
import { useIsMobile, useShowDeadline } from '../../../../businessLogics/hooks';
import { useEmailAuthConfirm } from '../../../../businessLogics/apis';
import AlertText from '../../../atoms/AlertText';
var ChangeEmailAuth = function () {
    var _a = useAtom(readWriteModalHistoryAtom), _ = _a[0], updateHistory = _a[1];
    var email = useAtomValue(emailAtom);
    var _b = useAtom(codeAtom), code = _b[0], setCode = _b[1];
    var _c = useState(false), isValidCode = _c[0], setIsValidCode = _c[1];
    var _d = useState(null), warningText = _d[0], setWarningText = _d[1];
    var _e = useState(new Date(new Date().setMinutes(new Date().getMinutes() + 3))), deadTime = _e[0], setDeadTime = _e[1];
    var _f = useState(true), showCountDown = _f[0], setShowCountDown = _f[1];
    var isMobile = useIsMobile();
    useShowDeadline(deadTime, setWarningText, showCountDown, '유효 시간이 만료되었습니다. 뒤로 돌아가 다시 시도해 주세요.');
    useEffect(function () {
        if (code.length > 0) {
            setIsValidCode(true);
        }
        else {
            setIsValidCode(false);
        }
    }, [code]);
    var putEmailAuthConfirm = useEmailAuthConfirm(setWarningText, setDeadTime, setShowCountDown);
    var onClickCta = function () {
        if (isValidCode && deadTime && deadTime > new Date())
            putEmailAuthConfirm.mutate({ code: code });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MainContents, __assign({ paddingTop: 112 }, { children: [_jsx(Title, { children: "\uBCC0\uACBD\uD560 \uC774\uBA54\uC77C \uC778\uC99D" }), _jsx(VerticalGap, { size: isMobile ? 8 : 12 }), _jsxs(Desc, { children: [email, "\uB85C", _jsx("br", {}), "\uC804\uC1A1\uB41C \uC778\uC99D\uBC88\uD638\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694."] }), _jsx(VerticalGap, { size: isMobile ? 20 : 40 }), _jsx(Input, { value: code, setValue: setCode, placeHolder: '인증번호 입력', type: 'number', maxLength: 5 }), _jsx(AlertText, __assign({ isShow: !!warningText, color: deadTime ? neutralDay.gray70 : scc.red100, spanColor: scc.red100 }, { children: warningText })), !isMobile && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: 40 }), _jsx(CtaBtn, __assign({ bgColor: isValidCode ? neutralDay.gray100 : '#1416174d', isInactive: !isValidCode, color: neutralDay.white, onClickAction: onClickCta }, { children: "\uC778\uC99D\uD558\uAE30" }))] }))] })), isMobile && (_jsx(BottomContents, { children: _jsx(CtaBtn, __assign({ bgColor: isValidCode ? neutralDay.gray100 : '#1416174d', isInactive: !isValidCode, color: neutralDay.white, onClickAction: onClickCta }, { children: "\uC778\uC99D\uD558\uAE30" })) }))] }));
};
export default ChangeEmailAuth;
//# sourceMappingURL=ChangeEmailAuth.js.map